// ----------------------------------------------------------------------

export default function Typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(1.5),
        },
        gutterBottom: {
          marginBottom: theme.spacing(0.75),
        },
      },
    },
  };
}
